module.exports = {
  bindEvents: function() {
    var _t = this;
    $(window).on('initQuantityInputs', _t.quantityInputInit);

    $(window).on('initShoplistsQuantityInputs', _t.quantityShoplistInputInit);

    $(window).on('calculateTotalOnCheckoutPage', _t.checkoutPageTotal);
    // _t.quantityInputInit();
  },

  /**
   * quantityInput
   */
  quantityInputInit: function(e) {
    $('.quantity')
      .not($('.init'))
      .each(function() {
        var el = $(this);
        el.addClass('init');
        var closestInput = el.find('#setQuantity');

        let currentQuantity = closestInput.val();

        el.find('.less')
          .off()
          .on('click', function() {
            $('#loading-cart-items-loader').fadeIn('fast');

            currentQuantity = Math.max(1, --currentQuantity);
            closestInput.val(currentQuantity);

            if (closestInput.hasClass('cart-page')) {
              var triggerUpdateQuantity = new CustomEvent('triggerUpdateQuantity', {
                detail: {
                  prod_id: closestInput.attr('prod_id'),
                  qty: currentQuantity
                }
              });
              // trigger refresh event on cart page
              window.dispatchEvent(triggerUpdateQuantity);
            }
          });

        el.find('.more')
          .off()
          .on('click', function() {
            currentQuantity++;
            closestInput.val(currentQuantity);

            $('#loading-cart-items-loader').fadeIn('fast');

            if (closestInput.hasClass('cart-page')) {
              var triggerUpdateQuantity = new CustomEvent('triggerUpdateQuantity', {
                detail: {
                  prod_id: closestInput.attr('prod_id'),
                  qty: currentQuantity
                }
              });
              // trigger refresh event on cart page
              window.dispatchEvent(triggerUpdateQuantity);
            }
          });
      });
  },

  quantityShoplistInputInit: function(e) {
    $('.quantity-shoplist')
      .not($('.init'))
      .each(function() {
        var el = $(this);
        el.addClass('init');
        var closestInput = el.find('.setQuantityShopList');

        let currentQuantity = closestInput.val();

        el.find('.less')
          .off()
          .on('click', function() {
            // $("#loading-cart-items-loader").fadeIn("fast");

            currentQuantity = Math.max(1, --currentQuantity);
            closestInput.val(currentQuantity);

            if (closestInput.hasClass('shopping-list-page')) {
              var triggerUpdateQuantity = new CustomEvent('triggerUpdateQuantityShoplist', {
                detail: {
                  prod_id: closestInput.attr('prod-id'),
                  shoplist_id: closestInput.attr('shoplist-id'),
                  qty: currentQuantity,
                  element: el
                }
              });
              // trigger refresh event on cart page
              window.dispatchEvent(triggerUpdateQuantity);
            }
          });

        el.find('.more')
          .off()
          .on('click', function() {
            currentQuantity++;
            closestInput.val(currentQuantity);

            // $("#loading-cart-items-loader").fadeIn("fast");

            if (closestInput.hasClass('shopping-list-page')) {
              var triggerUpdateQuantity = new CustomEvent('triggerUpdateQuantityShoplist', {
                detail: {
                  prod_id: closestInput.attr('prod-id'),
                  shoplist_id: closestInput.attr('shoplist-id'),
                  qty: currentQuantity,
                  element: el
                }
              });
              // trigger refresh event on cart page
              window.dispatchEvent(triggerUpdateQuantity);
            }
          });
      });
  },

  checkoutPageTotal: function(e) {
    let cartSubtotal = parseFloat($('#cart_subtotal_input').val());

    let newCartSubtotal = cartSubtotal;
    //have to modify cart subtotal then trigger shipping calculation costs
    $('#addInsurance, #addBags').iCheck('update');

    if ($('#addInsurance').prop('checked')) {
      //get value of total cart
      newCartSubtotal *= parseFloat(1.2);
    }

    if ($('#addBags').prop('checked')) {
      //get value of total cart
      // console.log(Math.ceil($("#order_total_items").val() / 10) * 10);
      newCartSubtotal = newCartSubtotal + parseFloat(3.5);
    }

    /**
     * checkout cart page
     */
    // $("#cartSubtotal").text(newCartSubtotal.toFixed(2));
    $('#extra-services-cost').text((+newCartSubtotal - +cartSubtotal).toFixed(2));
    // $("#totalCosts").text(newCartSubtotal.toFixed(2));

    /**
     * checkout shopping list page
     */

    window.dispatchEvent(new CustomEvent('triggerShippingCostCalculation'));
  }
};



// WEBPACK FOOTER //
// ./public/src/js/CustomEvents.js